import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export const apiVersionInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  if (req.url.startsWith(environment.apiBaseUrl)) {
    const cloned = req.clone({
      params: req.params.set('api-version', '2.0'),
    });
    return next(cloned);
  }
  return next(req);
};
